module.exports = __webpack_public_path__ + "assets/113f4ed9528dff291782542e66826812.mp3";